import { FingerprintData, FunctionsService, PaymentMethod } from "@/core";
import { firebase } from "@/infrastructure/firebase";
import { httpsCallable } from "@firebase/functions";

export const functionsService: FunctionsService = {
  async createBuyOrder(payload) {
    const result = await httpsCallable<
      {
        miles: number;
        productId: string;
        customerId: string;
        loyaltyStatus: string;

        firstName: string;
        lastName: string;
        frequentFlyerNumber: string;
        accountEmail: string;
        receivedMilesBefore: string;
        notes: string;
      },
      string
    >(
      firebase.functions,
      "createBuyOrder",
    )(payload);
    return result.data;
  },

  async createSellOrder(payload) {
    const result = await httpsCallable<
      {
        miles: number;
        customerId: string;
        productId: string;
        loyaltyStatus: string;

        frequentFlyerNumber: string;
        accountPassword: string;
        accountEmail: string;
        accountPhoneNumber: string;
        milesExpirationDate: string;
        paymentMethod: PaymentMethod;
        paypalEmail?: string;
        notes?: string;
      },
      string
    >(
      firebase.functions,
      "createSellOrder",
    )(payload);
    return result.data;
  },

  async createBuyOrderMVP(payload) {
    const result = await httpsCallable<
      {
        miles: number;
        productId: string;
        customerId: string;
        loyaltyStatus: string;
        firstName: string;
        lastName: string;
        frequentFlyerNumber: string;
        accountEmail: string;
        receivedMilesBefore: string | null;
        notes: string;
      },
      string
    >(
      firebase.functions,
      "createBuyOrderMVP",
    )(payload);
    return result.data;
  },

  async createSellOrderMVP(payload) {
    const result = await httpsCallable<
      {
        miles: number;
        customerId: string;
        productId: string;
        loyaltyStatus: string;
        frequentFlyerNumber: string;
        accountPassword: string;
        accountEmail: string;
        accountPhoneNumber: string;
        milesExpirationDate: string;
        paymentMethod?: PaymentMethod;
        paypalEmail?: string;
        notes?: string;
      },
      string
    >(
      firebase.functions,
      "createSellOrderMVP",
    )(payload);
    return result.data;
  },

  async correctAccountDetails(payload) {
    const result = await httpsCallable<
      {
        dealId: string;
        frequentFlyerNumber: string;
        accountEmail: string;
        accountPassword: string;
        fingerprint: FingerprintData;
      },
      string
    >(
      firebase.functions,
      "correctAccountDetails",
    )(payload);
    return result.data;
  },

  async createSecureQuote(payload) {
    const result = await httpsCallable<
      {
        temporaryDealId: string;
        quantity: number;
      },
      string
    >(
      firebase.functions,
      "createSecureQuote",
    )(payload);

    return result.data;
  },
  async emailQuote(payload) {
    const result = await httpsCallable<
      {
        temporaryDealId: string;
        quantity: number;
      },
      { result: string }
    >(
      firebase.functions,
      "emailQuote",
    )(payload);
    return {
      result: JSON.stringify(result.data),
    };
  },

  async followUpEmail(payload) {
    const result = await httpsCallable<
      {
        temporaryDealId: string;
        quantity: number;
      },
      { result: string }
    >(
      firebase.functions,
      "followUpEmail",
    )(payload);
    return {
      result: JSON.stringify(result.data),
    };
  },

  async createSellOrderFromTemporaryDeal(payload) {
    const result = await httpsCallable<
      {
        temporaryDealId: string;
        frequentFlyerNumber: string;
        accountEmail: string;
        accountPassword: string;
        accountPhoneNumber: string;
        milesExpirationDate: string;
        paymentMethod?: PaymentMethod;
        paypalEmail?: string;
        miles: number;
        productId: string;
        customerId: string;
        loyaltyStatus: string;
        notes?: string;
        fingerprint?: FingerprintData;
      },
      { result: string }
    >(
      firebase.functions,
      "createSellOrderFromTemporaryDeal",
    )(payload);
    return {
      result: JSON.stringify(result.data),
    };
  },
};
